import { FormField } from "../../../FormEngine/types";
import { z } from "zod";
import ExerciseList from "./ExerciseList";
/**
 * Exercise History form schema
 * 
 * This schema defines the fields for the Exercise History form
 * using the FormEngine component.
 */
export const exerciseHistorySchema: FormField[] = [
  {
		type: "custom",
		name: "exercises",
		title: "Exercises",
		description: "Please describe all types of exercise you do",
		component: ExerciseList,
	},
];

export default exerciseHistorySchema;